/**
 * Преобразует объект с параметрами в строку query-параметров.
 * Массивы сериализуются как key=value1&key=value2 (без [])
 */
export function toQueryString(params: Record<string, any>): string {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {
                searchParams.append(key, String(item));
            });
        } else if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
        }
    });

    return searchParams.toString();
}